<div class="mt-5 text-center">
    <p [innerHTML]="'Error.Error404' | translate"></p>
</div>